import { sendMetrics } from '@jusbrasil-web/shared-utils-events'

export function sendUnifiedClickEvent(button: string, pid?: number | null) {
  const metadata = {
    button,
  }

  sendMetrics('UserAccount.ProfileMenuClicked', pid?.toString(), { metadata })
}
